<script setup>
    import { ref } from 'vue';
    import * as yup from 'yup';
    import { useForm } from 'vee-validate';
    import CustomerServiceRepresentativeModal from './CustomerServiceRepresentativeModal.vue';
    import axios from 'axios';

    const defaultValues = { id: 0, name: "", email: "", isJdeSpecialist: false };
    const root = ref(null);
    const model = ref(defaultValues);
    let onSave = null;
    
    const { meta, errors, handleSubmit } = useForm({
        validationSchema: yup.object({
            name: yup.string().nullable().required(),
            email: yup.string().nullable().required()
        }),
    });

    const onSubmit = handleSubmit( async () => {
        try {
            onSave(model.value);
        }
        finally {
            toggleDisplay(false)
        }
    });

    const toggleDisplay = (value) => root.value.style.display = value ? "block" : "none";

    function open(item) {                
        model.value = Object.assign({}, item ?? defaultValues);

        return new Promise((resolve, reject) => {            
            //assign callbacks
            onSave = (result) => resolve(Object.assign(item ?? {}, result));
            toggleDisplay(true);
        });
    };

    defineExpose({
        open
    });
</script>

<template>
    <div ref="root" class="modal">
        <form @submit.prevent="onSubmit">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{model.id ? "Edit" : "Add"}} Customer Service Representative</p>
                    <button type="button" class="delete" aria-label="close" @click="toggleDisplay(false)"></button>
                </header>
                <section class="modal-card-body">
                    <div class="notification is-danger is-light" v-if="!meta.valid && submitted == true">
                        <div v-for="error in errors">
                            &bull; {{error}}
                        </div>
                    </div>

                    <div class="control">
                        <label class="label">Name *</label>
                        <Field class="input" type="text" v-model="model.name" name="name" />
                    </div>

                    <div class="control">
                        <label class="label">Email *</label>
                        <Field class="input" type="text" v-model="model.email" name="email" />
                    </div>

                    <div class="control mt-2">
                        <label class="label">Type</label>
                        <div class="radios">
                            <label class="radio">
                                <input type="radio" name="isJdeSpecialist" :value="false" v-model="model.isJdeSpecialist"> Order Recipient
                            </label>
                            <label class="radio">
                                <input type="radio" name="isJdeSpecialist" :value="true" v-model="model.isJdeSpecialist"> JDE Specialist <span class="material-icons md-18 cursor-help" title="When a package preparation checklist or return checklist is submitted, the JDE specialist will be notified by email to final amend JDE.">help</span>
                            </label>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot" style="justify-content:flex-end">
                    <div class="buttons">
                        <button type="submit" class="button is-success" @click="submitted = true"><i class="material-icons mr-1">save</i>Save</button>
                        <button type="button" class="button is-danger" @click="toggleDisplay(false)"><i class="material-icons mr-1">cancel</i>Cancel</button>
                    </div>
                </footer>
            </div>
        </form>
    </div>
</template>